import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const bulkUpdateStatusActionTypes = {
  BULK_UPDATE_STATUS: type('[Subscription] BULK UPDATE'),
  BULK_UPDATE_STATUS_SUCCESS: type('[Subscription] BULK UPDATE Success'),
  BULK_UPDATE_STATUS_FAIL: type('[Subscription] BULK UPDATE Fail'),
};

export class BulkUpdateStatusAction implements Action {
  readonly type = bulkUpdateStatusActionTypes.BULK_UPDATE_STATUS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class BulkUpdateStatusSuccessAction implements Action {
  readonly type = bulkUpdateStatusActionTypes.BULK_UPDATE_STATUS_SUCCESS;
  constructor(public payload?: string) {}
}

export class BulkUpdateStatusFailAction implements Action {
  readonly type = bulkUpdateStatusActionTypes.BULK_UPDATE_STATUS_FAIL;
  constructor(public payload?: string) {}
}
